import { Link } from "react-router-dom";
export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-14 items-center">
          {/* Text first on this layout */}
          <div>
            <span className="text-[#C8102E] text-xs font-bold tracking-[0.2em] uppercase">WHO WE ARE</span>
            <h2 className="text-3xl font-extrabold text-[#0B2447] mt-3 mb-5 leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Connecticut&apos;s Trusted HVAC Specialists
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              Ultimate Heating &amp; Cooling has served Connecticut homeowners since 2009. We started as a two-man operation and have grown into a team of 30+ NATE-certified technicians — all local, all licensed, all proud of the work they do.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              We specialize in high-efficiency HVAC systems, heat pumps, and indoor air quality — helping families save on energy bills while staying comfortable every month of the year.
            </p>
            <ul className="space-y-2.5 mb-8">
              {[
                "Carrier & Lennox Authorized Dealer",
                "Honest Upfront Pricing — No Surprises",
                "Clean Energy Rebate Options",
              ].map((item) => (
                <li key={item} className="flex items-center gap-3 text-sm text-gray-600">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 bg-[#C8102E]/10 rounded-full">
                    <i className="ri-check-line text-[#C8102E] text-xs font-bold"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <Link
              to="/contact"
              className="inline-block bg-[#0B2447] text-white font-bold text-sm px-8 py-3 rounded-full hover:bg-[#C8102E] transition-colors cursor-pointer whitespace-nowrap"
            >
              GET A FREE QUOTE
            </Link>
          </div>

          {/* Image on right */}
          <div className="relative pb-6 md:pb-0">
            <div className="w-full h-[300px] md:h-[420px] rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/36fff7c058435a92029a1d7ae462693c/2b2d4785ff770414ab216a5a633f652e.jpeg"
                alt="Ultimate Heating & Cooling technician"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* BBB Badge */}
            <div className="absolute -bottom-2 md:-bottom-5 left-2 md:-left-5 bg-[#0B2447] p-2.5 md:p-3 rounded-xl">
              <img
                src="https://storage.readdy-site.link/project_files/f6c24b4f-84f4-4d51-a5a2-519060acd333/78ee367c-4c41-4043-9f3a-f508413bfc15_OneCom-Media-Marketings-A-Better-Business-Bureau-Ranking.webp?v=bbd08f9f41540b6560691175dbeb14bc"
                alt="BBB A- Rating"
                className="w-16 md:w-20 h-auto"
              />
            </div>
            {/* Second accent badge */}
            <div className="absolute top-4 md:top-6 -right-2 md:-right-4 bg-[#0B2447] text-white px-3 md:px-4 py-2.5 md:py-3 rounded-xl text-center">
              <div className="text-lg md:text-xl font-extrabold text-[#C8102E]">5.0★</div>
              <div className="text-[9px] md:text-[10px] font-bold tracking-wider text-gray-300 uppercase">Google</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
